import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { welcomeRoute } from "../route-names";
import { ApiAboutService } from "../Services/api-about.service";

@Injectable()
export class CanActivateRegistration  {
    private registration_start: Date;
    private registration_close: Date;
    constructor(
        private router: Router,
        private aboutService: ApiAboutService
        ) {
            this.registration_start = new Date(this.aboutService.aboutInformation.value.org_feature_set.miscSettings?.registrationStartTimestamp ?? (this.aboutService.aboutInformation.value.org_feature_set.miscSettings?.electionStartTimestamp ?? "01-03-2009"));
            this.registration_close = new Date(this.aboutService.aboutInformation.value.org_feature_set.miscSettings?.registrationEndTimestamp ?? (this.aboutService.aboutInformation.value.org_feature_set.miscSettings?.electionEndTimestamp ?? "03-14-15926"));
        }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        let timeNow = new Date();
        if (this.registration_start <= timeNow && timeNow <= this.registration_close) {
            return true
        } else {
            return this.router.createUrlTree(welcomeRoute);
        }
    }
}